import CombinedCashFlowView from '@/components/cashflow/CombinedCashFlowView';
import { useShowAllInCashFlow } from '@/hooks/useShowAllInCashFlow';
import { AccountBase } from '@/models/AccountViewModel';
import AccountBaseUtility from '@/utils/accountBase.utility';
import InvestmentActivity from '@/widgets/investor/InvestmentActivity';
import {
  defaultTransactionPeriod,
  type TransactionPeriod,
} from './transactionPeriod';

interface TransactionViewRouterProps {
  account: AccountBase;
  investorId?: number;
  /** The range to show, picked above the tab; defaults to the month so far. */
  period?: TransactionPeriod;
}

/**
 * Renders the correct transaction component based on account type and advisor
 * settings: Cash Flow for banking accounts, or for every account when the
 * advisor group shows all transactions there, otherwise Trading Activity. A
 * direct replacement for the legacy AccountTransactions.jsx logic.
 */
export const TransactionViewRouter = ({
  account,
  investorId,
  period = defaultTransactionPeriod(),
}: TransactionViewRouterProps) => {
  const isBanking = AccountBaseUtility.isBanking(account);
  const showAllInCashFlow = useShowAllInCashFlow();

  if (showAllInCashFlow || isBanking) {
    return (
      <CombinedCashFlowView
        accountId={account.AccountId}
        investorId={investorId}
        size='flyout'
        startDate={period.startDate}
        endDate={period.endDate}
      />
    );
  }

  return (
    <InvestmentActivity
      accountId={account.AccountId}
      investorId={investorId}
      startDate={period.startDate}
      endDate={period.endDate}
      container='flyout'
    />
  );
};
